export default __webpack_public_path__ + "static/media/technology.4f01b893.png";